import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Title = styled.h2`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 1rem;
  line-height: 1rem;
  color: ${props => props.theme.colors.color545e6c};
`

export const Card = styled.div`
  width: 100%;
  padding: 1rem;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const CardLayout = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2vw;
`

export const Divisor = styled.div`
  position: relative;
  height: 70px;
  width: 1px;
  background: ${props => props.theme.colors.colorDCE3ED};
`

export const CheckUpLink = styled(Link)`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-decoration-line: underline;
  color: ${props => props.theme.colors.color378ff7};

  display: flex;
  align-self: baseline;
  justify-content: end;
  gap: 3px;
`
